import React, { useState } from 'react';
import { MetricData } from '../data/mockData';
import { MetricCard } from './MetricCard';
import { MetricDetailModal } from './MetricDetailModal';
interface ActivityMetricsProps {
  metrics: MetricData[];
}
export function ActivityMetrics({
  metrics
}: ActivityMetricsProps) {
  const [selectedMetric, setSelectedMetric] = useState<MetricData | null>(null);
  return <section className="mb-8" data-id="element-1">
      <h2 className="text-lg font-semibold text-white mb-4 flex items-center gap-2" data-id="element-2">
        <span className="w-1.5 h-5 bg-cyan-500 rounded-full" data-id="element-3"></span>
        Core Activity
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-4">
        {metrics.map(metric => <MetricCard key={metric.name} metric={metric} onClick={() => setSelectedMetric(metric)} data-id="element-5" />)}
      </div>

      {selectedMetric && <MetricDetailModal metric={selectedMetric} onClose={() => setSelectedMetric(null)} data-id="element-6" />}
    </section>;
}